import * as React from 'react';
import PropTypes from 'prop-types';
import {Form} from "semantic-ui-react";
import {Checkbox, TextField} from "material-ui";

const _edit = {
	name: '',
	default: false
};

class ModuleEdit extends React.Component {
	static propTypes = {
		module: PropTypes.object,
		onSubmit: PropTypes.func.isRequired,
		onReset: PropTypes.func,
		props: PropTypes.object,
		id: PropTypes.string.isRequired,
		loading: PropTypes.bool,
		children: PropTypes.node
	};
	
	static defaultProps = {
		props: {},
		id: 'module-edit',
		loading: false
	};
	
	state = {
		edit: this.props.module || _edit
	};
	
	update = (name, value) => this.setState(state => ({
		...state,
		edit: {
			...state.edit,
			[name]: value
		}
	}));
	
	reset = () => this.setState({
		edit: this.props.module || _edit
	});
	
	render = () => {
		const {onSubmit, id, loading, props, children} = this.props;
		const {edit: module} = this.state;
		return (
			<Form id={id} onSubmit={() => onSubmit(module)} {...props} loading={loading}>
				<Form.Field>
					<TextField
						value={module.name}
						hintText={'Name des Modules'}
						floatingLabelText={'Name des Modules'}
						required={true}
						onChange={(_, value) => this.update('name', value)}
					/>
				</Form.Field>
				<Form.Field>
					<Checkbox
						checked={module.default}
						label={'Standardmodule'}
						labelPosition={'right'}
						onCheck={(_, how) => this.update('default', how)}
					/>
				</Form.Field>
				{children}
			</Form>
		);
	};
}

export default ModuleEdit;


// WEBPACK FOOTER //
// ./src/components/ModuleEdit.js